import request from '@/utils/request';
import { BASE_API } from '@/utils/consts'

// 平台建档到店
export function getRecordInChannel(data) {
  return request(`${BASE_API}/channel/analysis/platform/customer`, {
    method: 'POST',
    data
  });
}

//平台渠道 升单
export function getUpInChannel(data) {
  return request(`${BASE_API}/channel/analysis/platform/upgrade_order`, {
    method: 'POST',
    data
  });
}

//平台渠道 收款
export function getCollectionInChannel(data) {
  return request(`${BASE_API}/channel/analysis/platform/payment`, {
    method: 'POST',
    data
  });
}

//平台渠道 消耗
export function getConsumeInChannel(data) {
  return request(`${BASE_API}/channel/analysis/platform/reservation_item`, {
    method: 'POST',
    data
  });
}

//平台升单排名 按渠道
export function getUpInRankByChannel(data) {
  return request(`${BASE_API}/rank/platform/upgrade-order/channel`, {
    method: 'POST',
    data
  });
}

//平台升单排名 按人
export function getUpInRankByPeople(data) {
  return request(`${BASE_API}/rank/platform/upgrade-order/consultant`, {
    method: 'POST',
    data
  });
}

//平台升单排名 按诊所
export function getUpInRankByClinic(data) {
  return request(`${BASE_API}/rank/platform/upgrade-order/clinic`, {
    method: 'POST',
    data
  });
}

//平台消耗排名 按渠道
export function getConsumeInRankByChannel(data) {
  return request(`${BASE_API}/rank/platform/consumption/channel`, {
    method: 'POST',
    data
  });
}

//平台消耗排名 按人
export function getConsumeInRankByPeople(data) {
  return request(`${BASE_API}/rank/platform/consumption/consultant`, {
    method: 'POST',
    data
  });
}

//平台消耗排名 按诊所
export function getConsumeInRankByClinic(data) {
  return request(`${BASE_API}/rank/platform/consumption/clinic`, {
    method: 'POST',
    data
  });
}

//平台消耗次数排名
export function getCountInRank(data) {
  return request(`${BASE_API}/rank/platform/consumption/times`, {
    method: 'POST',
    data
  });
}

//客户分析漏洞图
export function getCustomerByFunnel(data) {
  return request(`${BASE_API}/platform/customer-analysis/graph/funnel`, {
    method: 'POST',
    data
  });
}

//客户分析 升单分析
export function getUpgradeOrder(data) {
  return request(`${BASE_API}/platform/customer-analysis/list/upgrade-order`, {
    method: 'POST',
    data
  });
}

//客户分析 消耗分析
export function getConsumption(data) {
  return request(`${BASE_API}/platform/customer-analysis/list/consumption`, {
    method: 'POST',
    data
  });
}

//退款分析 人员分析
export function getPeopleInRefund(data) {
  return request(`${BASE_API}/refund/analysis/platform/employee`, {
    method: 'POST',
    data
  });
}

//退款分析 项目分析
export function getProjectInRefund(data) {
  return request(`${BASE_API}/refund/analysis/platform/reservation_item`, {
    method: 'POST',
    data
  });
}

//退款分析 渠道分析
export function getChannelInRefund(data) {
  return request(`${BASE_API}/refund/analysis/platform/channel`, {
    method: 'POST',
    data
  });
}

//项目分析 成交
export function getDealInfo(data) {
  return request(`${BASE_API}/project/analysis/platform/deal`, {
    method: 'POST',
    data
  });
}

//项目分析 升单
export function getUpInProject(data) {
  return request(`${BASE_API}/project/analysis/platform/upgrade_order`, {
    method: 'POST',
    data
  });
}

//项目分析 消耗
export function getConsumInProject(data) {
  return request(`${BASE_API}/project/analysis/platform/reservation_item`, {
    method: 'POST',
    data
  });
}

//项目分析 收入
export function getIncomeInProject(data) {
  return request(`${BASE_API}/project/analysis/platform/income`, {
    method: 'POST',
    data
  });
}

//平台--建档-到店趋势图
export function getRecordForChart(data) {
  return request(`${BASE_API}/tendency-chart/platform/document-arrive`, {
    method: 'POST',
    data
  });
}

//平台--升单趋势图
export function getUpForChart(data) {
  return request(`${BASE_API}/tendency-chart/platform/deal-upgrade`, {
    method: 'POST',
    data
  });
}

//平台--收款-升单趋势图
export function getCollectionForChart(data) {
  return request(`${BASE_API}/tendency-chart/platform/payment-upgrade`, {
    method: 'POST',
    data
  });
}

//平台--收入-消耗趋势图
export function getIncomeForChart(data) {
  return request(`${BASE_API}/tendency-chart/platform/income-consumption`, {
    method: 'POST',
    data
  });
}

//周月报表 整体情况
export function getAllAnalysis(data) {
  return request(`${BASE_API}/report/platform/overall`, {
    method: 'POST',
    data
  });
}

//DPP消耗分析
export function getDPPAnalysis(data) {
  return request(`${BASE_API}/dpp/analysis/platform/consumption`, {
    method: 'POST',
    data
  });
}

export async function queryProducts(data) {
  return request(`${BASE_API}/product/list`, {
    method: 'POST',
    data
  });
}

export function queryChannels(data) {
  return request(`${BASE_API}/channel/list`, {
    method: 'POST',
    data
  });
}

export async function queryCategory(data) {
  return request(`${BASE_API}/category/list`, {
    method: 'POST',
    data
  });
}